import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router, NavigationEnd } from "@angular/router";

@Component({
  selector: "app-introduction",
  templateUrl: "./introduction.component.html",
  styleUrls: ["./introduction.component.scss"],
})
export class IntroductionComponent implements OnInit {
  hideElement = false;
  showElement = false;

  constructor(private route: ActivatedRoute, public router: Router) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (event.url === "/private" || event.url === "/private#studyCases") {
          this.hideElement = true;
        } else {
          this.hideElement = false;
        }

        if (event.url === "/private" || event.url === "/private#studyCases") {
          this.showElement = false;
        } else {
          this.showElement = true;
        }
      }
    });
  }

  onAnchorClick() {
    this.route.fragment.subscribe((f) => {
      const element = document.querySelector("#" + f);
      if (element) {
        element.scrollIntoView();
      }
    });
  }

  ngOnInit() {
    var text = ["improve user experience", "design web interfaces", "develop code"];
    var counter = 0;
    var elem = document.getElementById("animated-text");
    setInterval(changeText, 3000);

    function changeText() {
      elem.innerHTML = text[counter];
      counter++;
      if (counter >= text.length) {
        counter = 0;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/introduction/introduction.component.ts